import config from "@/config"
import http from "@/utils/request"
export default {
  file: {
    manage: {
      url: `${config.API_URL}/file`,
      name: "获取文件列表",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      }
    }
  },
  image: {
    manage: {
      url: `${config.API_URL}/file`,
      name: "图片管理",
      getUnAuditList: async function (params) {
        return await http.get(`${this.url}/list/unAudit`, params) //获取未审核
      }
    }
  }
}
